import { toast } from "sonner";
import { Link2, Share2 } from "lucide-react";

const XMark = () => <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-current" aria-hidden><path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.828l-5.35-6.993L4.7 22H1.44l8.02-9.165L1 2h7l4.836 6.392L18.244 2Zm-1.197 18h1.8L7.04 3.9H5.1L17.047 20Z" /></svg>;

export default function ShareWolf({ d }) {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/wolf/${encodeURIComponent(d.wolf_name)}`;
  const minted = d.looks.filter((l) => l.minted).length;
  const text = `Meet ${d.wolf_name}, level ${d.level} in Wolfpack Games${d.looks.length ? `, with ${d.looks.length} one-of-a-kind 1/1 wolf${d.looks.length === 1 ? "" : "s"}${minted ? ` (${minted} minted)` : ""}` : ""}. Come hunt with the pack!`;
  return <ShareButtons url={url} text={text} title={`${d.wolf_name} · Wolfpack Games`} tid="wolfpage-share" />;
}

export function ShareButtons({ url, text, title, tid, className = "mt-5" }) {
  const x = `https://x.com/intent/post?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied. Paste it into Discord or anywhere."); }
    catch { toast.error("Couldn't copy. Copy the address bar instead."); }
  };
  const native = () => navigator.share({ title, text, url }).catch(() => {});
  const btn = "inline-flex items-center gap-2 h-10 px-4 rounded-full border text-xs font-semibold transition-colors";
  return (
    <div className={`flex flex-wrap justify-center sm:justify-start gap-2 ${className}`} data-testid={tid}>
      <a href={x} target="_blank" rel="noreferrer" data-testid={`${tid}-x`} className={`${btn} border-slate-600 text-white hover:bg-white hover:text-black`}><XMark />Post on X</a>
      <button data-testid={`${tid}-copy`} onClick={copy} className={`${btn} border-indigo-400/60 text-indigo-200 hover:bg-indigo-500/15`}><Link2 className="w-4 h-4" />Copy link for Discord</button>
      {typeof navigator.share === "function" && (
        <button data-testid={`${tid}-native`} onClick={native} className={`${btn} border-amber-400/60 text-amber-200 hover:bg-amber-500/10`}><Share2 className="w-4 h-4" />Share</button>
      )}
    </div>
  );
}
